export const ModalBackdrop = (props: { onExit?: () => void }) => {
  return (
    <div
      className="bg-modalBackdropColor fixed bottom-0 left-0 right-0 top-0 z-30 h-screen w-screen bg-opacity-50 backdrop-blur-sm backdrop-filter"
      onClick={props.onExit}
    />
  );
};
